
// Hook for managing temporary session storage

// Store session data in temporary storage for verification process
export const storeSessionData = (email: string, fullName: string): void => {
  const sessionData = { email, fullName };
  localStorage.setItem("aimaa_temp_session", JSON.stringify(sessionData));
};

// Get temporary session data for verification
export const getSessionData = (): { email: string; fullName: string } | null => {
  const data = localStorage.getItem("aimaa_temp_session");
  if (!data) return null;
  
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
};

// Clear temporary session data
export const clearSessionData = (): void => {
  localStorage.removeItem("aimaa_temp_session");
};

// Store user data in localStorage
export const storeUserData = (userData: { email: string; fullName: string }): void => {
  localStorage.setItem("aimaa_user", JSON.stringify(userData));
};

// Get user data from localStorage
export const getUserData = (): { email: string; fullName: string } | null => {
  const storedUser = localStorage.getItem("aimaa_user");
  if (!storedUser) return null;
  
  try {
    return JSON.parse(storedUser);
  } catch (error) {
    console.error("Failed to parse user from localStorage:", error);
    localStorage.removeItem("aimaa_user");
    return null;
  }
};

// Clear user data from localStorage
export const clearUserData = (): void => {
  localStorage.removeItem("aimaa_user");
};
